import { useEffect, useState } from 'react';

const getElementPosition = (element) => {
  const rect = element.getBoundingClientRect();
  return {
    x: rect.left + window.scrollX,
    y: rect.top + window.scrollY,
  };
};

const useElementPosition = (elementRef, changeValue) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const updatePosition = () => {
      if (elementRef.current) {
        setPosition(getElementPosition(elementRef.current));
      }
    };

    window.addEventListener('scroll', updatePosition);
    window.addEventListener('resize', updatePosition);
    updatePosition();

    return () => {
      window.removeEventListener('scroll', updatePosition);
      window.removeEventListener('resize', updatePosition);
    };
  }, [elementRef, changeValue]);

  return position;
};

export default useElementPosition;
